import type { FatigueStatus } from "./types";

export const fatigueBadgeVariant: Record<
  FatigueStatus,
  "error" | "warning" | "info" | "success" | "subtle"
> = {
  severe: "error",
  refresh: "warning",
  monitor: "info",
  healthy: "success",
  new: "subtle",
};

// -- Impact tiers (based on relative spend share) --

export type ImpactTier = "very_high" | "high" | "medium" | "low";

export const impactLabels: Record<ImpactTier, string> = {
  very_high: "Very high",
  high: "High",
  medium: "Medium",
  low: "Low",
};

/** Compute impact tier from ad spend as a share of total account spend */
export function getImpactTier(adSpend: number, totalSpend: number): ImpactTier {
  if (totalSpend <= 0) return "low";
  const share = adSpend / totalSpend;
  if (share >= 0.1) return "very_high";
  if (share >= 0.05) return "high";
  if (share >= 0.02) return "medium";
  return "low";
}
